import { appendCss } from '../utils/commonUtils';
import { WIDGETGLOBALNAME } from '../config/constant';
import { cdnPath } from './config.json';
import { getCustomizeParams, getTargetScriptInfos } from './sdkHost';
import appendScript from './jsscript';

const {
  query,
  preUrlOfStaticResouce,
  apiHost,
} = getTargetScriptInfos();

try {
  const sdkExport = { [cdnPath]: `${preUrlOfStaticResouce}/` };

  const widgetCaller = (() => {
    let widgetReadyCallbackCalled = false;
    let widgetJSReady = false;
    let outerCallback;

    const runner = fn => (params) => {
      fn(params);
      if (!widgetReadyCallbackCalled && widgetJSReady && outerCallback) {
        widgetReadyCallbackCalled = true;
        outerCallback(window[WIDGETGLOBALNAME]);
      }
    };

    return {
      setWidgetReady: runner(() => {
        widgetJSReady = true;
      }),
      setCallback: runner((callback) => {
        outerCallback = callback;
      }),
    };
  })();

  sdkExport.CUIWidget = {
    onReady: widgetCaller.setCallback,
    apiHost,
    version: process.env.VERSION,
  };

  Object.assign(window, sdkExport);

  const params = getCustomizeParams(query, [ 'widgets' ]);

  if (query.widgets) {
    query.widgets.split(',').forEach((widget) => {
      appendScript(`${preUrlOfStaticResouce}/${widget}Widget.min.js${params}`, widgetCaller.setWidgetReady);
      appendCss(`${preUrlOfStaticResouce}/${widget}Widget.css${params}`);
    });
  } else {
    appendScript(`${preUrlOfStaticResouce}/widgets.min.js${params}`, widgetCaller.setWidgetReady);
    appendCss(`${preUrlOfStaticResouce}/widgets.css${params}`);
  }
} catch (error) {
  throw new Error(`The host is incorrect, please double check! Original error: ${ JSON.stringify(error)}`);
}
